// extracted by mini-css-extract-plugin
export var adjacentSlide = "_pw-9";
export var arrowButtonContainer = "_pw-5";
export var arrowButtonIcon = "_pw-6";
export var carouselArrowButton = "_pw-2";
export var carouselElementContainer = "_pw-1";
export var currentSlide = "_pw-8";
export var left = "_pw-3";
export var otherSlide = "_pw-a";
export var productCarouselContainer = "_pw-0";
export var right = "_pw-4";
export var sliderOverflow = "_pw-7";